module.exports = __webpack_public_path__ + "img/satellite.e0026255.svg";